import { ChevronRight } from "@mui/icons-material";
import { List, ListItemButton, ListSubheader, Typography } from "@mui/material";
import { Fragment, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router";

import { MapEditorFeatureList_FeatureFragment } from "./fragments.generated";
import groupMapEditorFeatures from "./groupMapEditorFeatures";
import MapEditorFeatureListItem from "./MapEditorFeatureListItem";

type Props = {
    mapEditorFeatures: MapEditorFeatureList_FeatureFragment[];
};

export default function MapEditorFeatureList({ mapEditorFeatures }: Props) {
    const { t } = useTranslation("mapEditor");
    const { search } = useLocation();

    const groupedFeatures = useMemo(() => groupMapEditorFeatures(mapEditorFeatures, t), [mapEditorFeatures, t]);

    return (
        <List sx={{ padding: 0 }}>
            {mapEditorFeatures.length < 1 && (
                <Typography padding={2}>{t("mapEditorFeatureList.labelNoFeatures")}</Typography>
            )}
            {groupedFeatures.map(({ id: groupId, name, features }) => (
                <Fragment key={groupId}>
                    <ListSubheader
                        sx={theme => ({
                            borderBottom: `1px solid ${theme.palette.divider}`,
                            backgroundColor: theme.palette.background.default,
                        })}
                    >
                        <Typography flex={1} variant="overline" fontWeight="bold">
                            {name}
                        </Typography>
                    </ListSubheader>
                    {features.map(feature => (
                        <ListItemButton key={feature.id} component={Link} to={{ pathname: feature.id, search }}>
                            <MapEditorFeatureListItem feature={feature} />
                            <ChevronRight />
                        </ListItemButton>
                    ))}
                </Fragment>
            ))}
        </List>
    );
}
